import * as RadixPopover from "@radix-ui/react-popover";
import { PropsWithChildren } from "react";
import { Tippy } from "./Tippy";
import clsx from "clsx";

type Variant = "ERROR";

interface PopoverContentProps extends RadixPopover.PopoverContentProps {
  variant: Variant;
}

function PopoverContent({ variant, children, className, side, align, sideOffset = 0, ...props }: PopoverContentProps) {
  return (
    <RadixPopover.Content
      {...props}
      align={align}
      side={side}
      sideOffset={sideOffset}
      className={clsx(
        "z-99999 flex flex-col gap-1 py-3 px-4 rounded-lg border max-w-[calc(200px+32px)] drop-shadow-xl",
        { "bg-red-100 border-red-200": variant === "ERROR" },
        className
      )}
    >
      {children}
      <Arrow align={align} side={side} variant={variant} />
    </RadixPopover.Content>
  );
}

interface ArrowProps {
  variant: Variant;
  side: RadixPopover.PopoverContentProps["side"];
  align: RadixPopover.PopoverContentProps["align"];
}

function Arrow({ align, side, variant }: ArrowProps) {
  return (
    <ErrorPopover.Arrow asChild>
      <div
        className={clsx("translate-y-0", {
          "translate-x-[5px]":
            (align === "start" && (side === "top" || side === "right")) ||
            (align === "end" && (side === "bottom" || side === "left")),
          "-translate-x-[5px]":
            (align === "start" && (side === "bottom" || side === "left")) ||
            (align === "end" && (side === "top" || side === "right")),
        })}
      >
        <Tippy variant={variant} />
      </div>
    </ErrorPopover.Arrow>
  );
}

function PopoverHeader({ children }: PropsWithChildren) {
  return <h2 className="text-xs font-medium text-blue-grey-950">{children}</h2>;
}

function PopoverBody({ children }: PropsWithChildren) {
  return <p className="text-xs font-normal text-blue-grey-950/50 m-0">{children}</p>;
}

export const ErrorPopover = {
  ...RadixPopover,
  Content: PopoverContent,
  Header: PopoverHeader,
  Body: PopoverBody,
};
